import dynamic from 'next/dynamic';
import React from 'react';

import TYPENAMES from './typeNames';

export default {
  [TYPENAMES.articleOverview]: {
    Component: dynamic(() => import('../../components/ArticleOverview')),
    grid: true,
  },
  [TYPENAMES.mediaOverview]: {
    Component: dynamic(() => import('../../components/MediaOverview')),
    grid: true,
  },
  [TYPENAMES.donationForm]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableDonationForm')
    ),
    grid: true,
  },
  [TYPENAMES.membershipForm]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableMembershipForm')
    ),
    grid: true,
  },
  [TYPENAMES.catalogOverview]: {
    Component: dynamic(() =>
      import('../../components/catalog/CatalogOverview')
    ),
    grid: true,
  },
  [TYPENAMES.personOverview]: {
    Component: dynamic(() => import('../../components/Person/PersonOverview')),
    grid: true,
  },
  [TYPENAMES.personNavigation]: {
    Component: dynamic(() =>
      import('../../components/Person/PersonNavigation')
    ),
    grid: true,
  },
  [TYPENAMES.personItem]: {
    Component: dynamic(() => import('../../components/Person/PersonOverview')),
    grid: true,
  },
  [TYPENAMES.catalogNavigation]: {
    Component: dynamic(() =>
      import('../../components/catalog/CatalogNavigation')
    ),
    grid: true,
  },
  [TYPENAMES.text]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableText')
    ),
    grid: true,
  },
  [TYPENAMES.button]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableButton')
    ),
    grid: true,
  },
  [TYPENAMES.imageAndText]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableImageAndText')
    ),
    grid: true,
  },
  [TYPENAMES.quote]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableQuote')
    ),
    grid: true,
  },
  [TYPENAMES.urlReference]: {
    Component: dynamic(
      () => import('../../composable-components/ComposableUrlReference'),
      {
        ssr: false,
        loading: () => <div />,
      }
    ),
    grid: true,
  },
  [TYPENAMES.onboardingBanner]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableOnboardingBanner')
    ),
    grid: false,
  },
  [TYPENAMES.photo]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableImage')
    ),
    grid: true,
  },
  [TYPENAMES.heading]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableHeading')
    ),
    grid: true,
  },
  [TYPENAMES.articleHeader]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableArticleHeader')
    ),
    grid: true,
  },
  [TYPENAMES.mediaViewed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableMediaViewed')
    ),
  },
  [TYPENAMES.mediaHeader]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableMediaHeader')
    ),
    grid: true,
  },
  [TYPENAMES.articleHeaderImage]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableArticleHeaderImage')
    ),
    grid: true,
  },

  [TYPENAMES.articleViewed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableArticleViewed')
    ),
  },

  [TYPENAMES.qualifioEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableQualifio')
    ),
    grid: true,
  },
  [TYPENAMES.youtubeEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableYoutube')
    ),
    grid: true,
  },
  [TYPENAMES.tweetEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableTweet')
    ),
    grid: true,
  },
  [TYPENAMES.audioEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableAudio')
    ),
  },
  [TYPENAMES.spotifyEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableSpotify')
    ),
    grid: true,
  },
  [TYPENAMES.instagramEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableInstagram')
    ),
    grid: true,
  },
  [TYPENAMES.facebookEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableFacebook')
    ),
    grid: true,
  },
  [TYPENAMES.theaterPlayerEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableMediaPlayer')
    ),
  },
  [TYPENAMES.playerEmbed]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableMediaPlayer')
    ),
    grid: true,
  },
  [TYPENAMES.assetCollection]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableAssetCollection')
    ),
    grid: true,
  },
  [TYPENAMES.teaser]: {
    Component: dynamic(() => import('../../components/Teasers/TeaserContent')),
    grid: false,
  },
  [TYPENAMES.spacer]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableGridSpacer')
    ),
    grid: true,
  },
  [TYPENAMES.cardList]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableCardList')
    ),
    grid: true,
  },
  [TYPENAMES.cardOverview]: {
    Component: dynamic(() => import('../../components/cards/CardOverview')),
    grid: true,
  },
  [TYPENAMES.topBar]: {
    Component: dynamic(() => import('../../components/Topbar')),
    grid: false,
  },
  [TYPENAMES.brandHeader]: {
    Component: dynamic(() => import('../../components/headers/BrandHeader')),
    grid: false,
  },
  [TYPENAMES.standalonePageHeader]: {
    Component: dynamic(() =>
      import('../../components/headers/StandalonePageHeader')
    ),
    grid: false,
  },
  [TYPENAMES.profileHeader]: {
    Component: dynamic(() => import('../../components/headers/ProfileHeader')),
    grid: false,
  },
  [TYPENAMES.onboardingInformationLink]: {
    Component: dynamic(() =>
      import('../../components/OnboardingInformationLink')
    ),
    grid: false,
  },
  [TYPENAMES.subNavigation]: {
    Component: dynamic(() => import('../../components/SubNavigation')),
    grid: false,
  },
  [TYPENAMES.brandTitleBar]: {
    Component: dynamic(() => import('../../components/BrandTitleBar')),
    grid: false,
  },
  [TYPENAMES.socialFooter]: {
    Component: dynamic(() => import('../../components/SocialFooter')),
    grid: false,
  },
  [TYPENAMES.footer]: {
    Component: dynamic(() => import('../../components/Footer')),
    grid: false,
  },
  [TYPENAMES.form]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableForm')
    ),
    grid: true,
  },
  [TYPENAMES.likeButton]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableLikeButton')
    ),
    grid: true,
  },
  [TYPENAMES.comments]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableComments')
    ),
    grid: false,
  },

  [TYPENAMES.download]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableDownload')
    ),
    grid: true,
  },
  [TYPENAMES.newsletterSubscription]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableNewsletterSubscription')
    ),
    grid: true,
  },
  [TYPENAMES.tagList]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableTagList')
    ),
    grid: true,
  },
  [TYPENAMES.recommendationList]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableRecommendation')
    ),
    grid: true,
  },
  [TYPENAMES.popularByBrandRecommendationList]: {
    Component: dynamic(() =>
      import(
        '../../composable-components/ComposablePopularRecommendationByBrand'
      )
    ),
    grid: true,
  },
  [TYPENAMES.popularRecommendationList]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposablePopularRecommendation')
    ),
    grid: true,
  },
  [TYPENAMES.sterBanner]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposableSterBanner')
    ),
    grid: false,
  },
  [TYPENAMES.scrollIntoView]: {
    Component: dynamic(() => import('../../components/ScrollIntoView')),
    grid: false,
  },
  [TYPENAMES.tagOrCategoryItems]: {
    Component: dynamic(() => import('../../components/TagOrCategoryItems')),
    grid: true,
  },
  [TYPENAMES.brandNavigation]: {
    Component: dynamic(() => import('../../components/Brandnavigation')),
    grid: false,
  },
  [TYPENAMES.profile]: {
    Component: dynamic(() => import('../../components/Profile')),
    grid: true,
  },
  [TYPENAMES.propositionList]: {
    Component: dynamic(() =>
      import('../../composable-components/ComposablePropositionCardList')
    ),
    grid: true,
  },
  [TYPENAMES.unsubscribeEmailNotification]: {
    Component: dynamic(() =>
      import(
        '../../components/UnsubscribeEmailNotifications/UnsubscribeEmailNotifications'
      )
    ),
    grid: true,
  },
  [TYPENAMES.welcomeDashboard]: {
    Component: dynamic(() =>
      import('../../components/WelcomeDashboard/WelcomeDashboard')
    ),
    grid: true,
  },
};
